import React from 'react';

import { InstagramFilled } from '@ant-design/icons';
import styles from './index.module.scss';
import {
  IconInstagram, IconTwiter, IconWhatsAppOutlined, IconWhatsFacebook, IconWhatsLinkedin, IconYoutubeFilled,
} from '../Icon';

const socialLinks = [
  { href: 'https://www.facebook.com/profile.php?id=61576325549165', imgSrc: <IconWhatsFacebook />, label: 'Facebook' },
  { href: 'https://www.linkedin.com/company/tipping-guide/about/', imgSrc: <IconWhatsLinkedin />, label: 'Linkedin' },
  { href: 'https://www.instagram.com/tippingguide/', imgSrc: <IconInstagram />, label: 'Instagram' },
  { href: 'https://x.com/TippingGuide_', imgSrc: <IconTwiter />, label: 'Twiter' },
  { href: 'https://www.youtube.com/@TippingGuide', imgSrc: <IconYoutubeFilled />, label: 'Youtube' },
];

export default function FollowUs(): React.ReactElement {
  return (
    <div className={styles.content}>
      <span>Follow Us</span>
      <div className={styles.links}>
        {socialLinks.map((item) => (
          <a
            href={item.href}
            key={item.label}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
          >
            {item.imgSrc}
          </a>
        ))}
      </div>
    </div>
  );
}
